/**
 * Created by DejanK on 1/11/2017.
 *
 * rbInputInteger
 */
import angular from 'angular';

export default {
  template: templateFn,
  bindings: {
    model: '='
  }
};

templateFn.$inject = ['$attrs', 'RbInputTemplate'];
function templateFn($attrs, RbInputTemplate){
  const options = angular.extend(RbInputTemplate.readDefaultAttributes($attrs));
  return RbInputTemplate.integerTemplate(options);
}
